// extracted by mini-css-extract-plugin
export default {"centered":"style--centered--3b524f","right":"style--right--619236","noWrap":"style--noWrap--f163ee"};